'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('getRole', ['SuperAdmin', 'AdOperationsManager', 'AdOperations',
    'SalesManager', 'SalesSupport', 'Sales', 'Partner', 'Vendor', 'VendorRestricted', 'Client', 'Viewer', 'SalesViewer',
    function (SuperAdmin,
              AdOperationsManager,
              AdOperations,
              SalesManager,
              SalesSupport,
              Sales,
              Partner,
              Vendor,
              VendorRestricted,
              Client, Viewer, SalesViewer) {
        let _private = {
            superadmin: SuperAdmin,
            ad_operations_manager: AdOperationsManager,
            ad_operations: AdOperations,
            sales_manager: SalesManager,
            sales_support: SalesSupport,
            sales: Sales,
            partner: Partner,
            vendor: Vendor,
            vendor_restricted: VendorRestricted,
            client: Client,
            viewer: Viewer,
            sales_viewer: SalesViewer
        };

        return function (roleName) {
            let name = typeof roleName === 'string' ? roleName.replace(/ /g, '') : '';
            if (_private[name]) {
                return _private[name];
            }

            return false;
        };
    }]);